import { FieldProps } from 'formik'
import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Participant } from 'gql.generated'
import * as React from 'react'

export const ProvingDetailsResourceParticipantForm: React.FC<{
  participants: Participant[]
}> = (props) => {
  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="participantId"
          render={(fieldProps: FieldProps<any>) => (
            <FormikDropdown
              label={'Teilnehmer'}
              {...fieldProps}
              options={props.participants
                .filter((y) => y.person)
                .map((x) => {
                  return {
                    key: x._id,
                    text: x.person!.name,
                  }
                })}
            />
          )}
        />
      </FieldStack>
    </FormStack>
  )
}
